/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Suggestions_Apply_FailedInputs */



/**
* | output |
* | --- |
* | "This change could not be applied to the document. It stays open so you can try again." |
*
* @param {Suggestions_Apply_FailedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const suggestions_apply_failed = /** @type {((inputs?: Suggestions_Apply_FailedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Suggestions_Apply_FailedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Diese Änderung konnte nicht auf das Dokument angewendet werden. Sie bleibt offen, damit du es erneut versuchen kannst.")
	return /** @type {LocalizedString} */ ("This change could not be applied to the document. It stays open so you can try again.")
});